{
  "app": { "name": "Kinta", "tagline": "Znaj koliko možeš potrošiti." },
  "common": {
    "loading": "Učitavanje…",
    "save": "Spremi",
    "cancel": "Odustani",
    "close": "Zatvori",
    "back": "Natrag",
    "retry": "Pokušaj ponovno",
    "email": "E-pošta",
    "password": "Lozinka",
    "newPassword": "Nova lozinka",
    "name": "Naziv",
    "optional": "neobavezno",
    "or": "ili",
    "offline": "Niste na mreži. Promjene će se sinkronizirati kad se vratite online.",
    "updateReady": "Nova verzija je spremna.",
    "reload": "Ažuriraj",
    "delete": "Obriši",
    "errors": {
      "generic": "Nešto je pošlo po zlu. Pokušaj ponovno.",
      "network": "Nema veze. Pokušaj ponovno kad budeš online.",
      "forbidden": "Nemaš dopuštenje za to.",
      "notFound": "To više ne postoji.",
      "conflict": "To već postoji.",
      "required": "Ovo polje je obavezno.",
      "loadFailed": "Učitavanje nije uspjelo. Pokušaj ponovno."
    }
  },
  "nav": {
    "main": "Glavni izbornik",
    "home": "Početna",
    "transactions": "Transakcije",
    "budgets": "Proračuni",
    "more": "Više",
    "add": "Dodaj",
    "search": "Traži ili idi na…",
    "go": "Idi na"
  },
  "auth": {
    "login": { "title": "Dobrodošli natrag", "submit": "Prijava", "toRegister": "Novi ste? Otvorite račun", "forgot": "Zaboravljena lozinka?" },
    "register": { "title": "Otvorite račun", "submit": "Otvori račun", "toLogin": "Već imate račun? Prijavite se", "fullName": "Vaše ime", "terms": "Otvaranjem računa prihvaćate:" },
    "google": { "continue": "Nastavi s Googleom", "failed": "Google prijava nije uspjela. Pokušajte ponovno." },
    "forgot": { "title": "Ponovno postavljanje lozinke", "body": "Unesite e-poštu i poslat ćemo vam poveznicu.", "submit": "Pošalji poveznicu", "sent": "Ako za tu e-poštu postoji račun, poveznica je poslana." },
    "reset": { "title": "Odaberite novu lozinku", "submit": "Promijeni lozinku", "done": "Lozinka je promijenjena. Prijavite se novom lozinkom.", "invalid": "Poveznica je neispravna ili je istekla." },
    "verify": { "title": "Potvrdite e-poštu", "working": "Potvrđivanje…", "ok": "E-pošta je potvrđena. Hvala!", "invalid": "Poveznica za potvrdu je neispravna ili je istekla.", "continue": "Nastavi" },
    "banner": {"unverified": "Poslali smo poveznicu za potvrdu na {{email}}. Otvorite je kako biste otključali sve mogućnosti.", "resend": "Pošalji ponovno", "resendIn": "Ponovno za {{seconds}} s", "resent": "E-pošta je poslana. Provjerite pristiglu poštu i neželjenu poštu.", "tooSoon": "Pričekajte trenutak prije novog zahtjeva.", "dismiss": "Sakrij"},
    "errors": {
      "invalidCredentials": "Pogrešna e-pošta ili lozinka.",
      "emailTaken": "Račun s tom e-poštom već postoji.",
      "tooMany": "Previše pokušaja. Pričekajte minutu pa pokušajte ponovno.",
      "generic": "Nešto je pošlo po zlu. Pokušajte ponovno."
    },
    "validation": { "email": "Unesite ispravnu adresu e-pošte.", "required": "Ovo polje je obavezno.", "passwordShort": "Koristite najmanje 10 znakova." },
    "signOut": "Odjava"
  },
  "install": {
    "title": "Instaliraj aplikaciju",
    "body": "Otvarajte je s početnog zaslona, preko cijelog zaslona, i unosite troškove i bez mreže.",
    "button": "Instaliraj",
    "later": "Ne sada",
    "ios": "Dodirnite Dijeli, zatim „Dodaj na početni zaslon”."
  },
  "household": {
    "title": "Kućanstvo",
    "workspaces": "Radni prostori",
    "active": "Aktivni radni prostor",
    "newWorkspace": "Novi radni prostor",
    "rename": "Preimenuj",
    "deleteWorkspace": "Obriši radni prostor",
    "deleteTitle": "Obrisati {{name}}?",
    "deleteBody": "Time se briše radni prostor i svi njegovi podaci za sve članove. Ovo se ne može poništiti.",
    "members": "Članovi",
    "you": "vi",
    "roleOf": "Uloga: {{name}}",
    "role": "Uloga",
    "remove": "Ukloni",
    "removeTitle": "Ukloniti ovu osobu?",
    "removeBody": "{{name}} će izgubiti pristup ovom radnom prostoru.",
    "leave": "Napusti radni prostor",
    "leaveTitle": "Napustiti ovaj radni prostor?",
    "leaveBody": "Gubite pristup dok vas netko ponovno ne pozove.",
    "invitations": "Pozivnice",
    "noInvitations": "Nema pozivnica na čekanju.",
    "invite": "Pozovi nekoga",
    "inviteHint": "Šaljemo im poveznicu koja vrijedi 7 dana.",
    "sendInvite": "Pošalji pozivnicu",
    "revoke": "Otkaži",
    "inviteInvalid": "Unesite ispravnu email adresu.",
    "inviteConflict": "Ta osoba je već ovdje ili slanje emaila nije postavljeno.",
    "viewOnly": "U ovom radnom prostoru možete samo gledati, ne i mijenjati.",
    "roles": {
      "owner": "Vlasnik",
      "admin": "Upravitelj",
      "member": "Član",
      "viewer": "Gledatelj"
    },
    "roleHint": {
      "admin": "uređuje i upravlja ljudima",
      "member": "uređuje unose",
      "viewer": "samo čitanje"
    },
    "invitePage": {
      "title": "Pozvani ste",
      "body": "{{inviter}} vas je pozvao u {{workspace}} kao: {{role}}.",
      "forEmail": "Ova pozivnica je za {{email}}.",
      "accept": "Pridruži se",
      "notFound": "Ova poveznica pozivnice nije valjana.",
      "used": "Ova pozivnica je već iskorištena.",
      "expired": "Ova pozivnica je istekla. Zatražite novu.",
      "wrongAccount": "Pozivnica je poslana na drugu email adresu. Prijavite se s njom.",
      "verifyFirst": "Prvo potvrdite email, pa se vratite na ovu poveznicu.",
      "pending": "Čeka vas pozivnica.",
      "open": "Otvori"
    }
  },
  "account": {
    "title": "Vaši podaci",
    "body": "Preuzmite kopiju svega što vidite ili trajno obrišite račun.",
    "export": "Preuzmi moje podatke",
    "exportFailed": "Datoteku nije moguće pripremiti. Pokušajte ponovno.",
    "delete": {
      "open": "Obriši račun",
      "title": "Obrisati račun?",
      "body": "Time se brišu vaš račun, vaši radni prostori i sve transakcije, proračuni i računi u njima. Ovo se ne može poništiti. Prvo preuzmite podatke ako želite kopiju.",
      "typeEmail": "Upišite {{email}} za potvrdu",
      "confirm": "Obriši sve",
      "wrongInput": "Email ili lozinka ne odgovaraju.",
      "sharedWorkspace": "U vašem radnom prostoru još ima drugih članova. Prvo ih uklonite, pa pokušajte ponovno."
    },
    "legal": {
      "privacy": "Politika privatnosti",
      "terms": "Uvjeti korištenja"
    }
  },
  "legal": {
    "back": "Natrag",
    "draftNote": "Radni tekst. Podaci o operateru upisuju se prije lansiranja.",
    "updated": "Zadnja izmjena: {{date}}",
    "contact": "Pitanja: {{email}}",
    "privacy": {
      "title": "Politika privatnosti",
      "sections": [
        {
          "h": "Tko smo",
          "p": "{{name}} je aplikacija za osobne financije. Operater usluge je {{operator}}. Kontakt: {{email}}."
        },
        {
          "h": "Što pohranjujemo",
          "p": "Vaš email, ime (ako ga unesete), jezik i hash lozinke (nikad samu lozinku). Ako se prijavite putem Googlea, primamo identifikator Google računa i potvrđeni email. Sve što unesete: račune, transakcije, kategorije, proračune, kredite i pretplate, ciljeve, fotografije računa i postavke radnog prostora. Tehničke podatke: IP adresu i naziv uređaja za sesije prijave i sigurnosne zapise."
        },
        {
          "h": "Zašto ih koristimo",
          "p": "Za rad aplikacije za vas (ugovor), za sigurnost i sprječavanje zlouporabe (legitimni interes) te za naplatu i porezne obveze (zakonska obveza). Ne prodajemo vaše podatke, ne prikazujemo oglase i ne gradimo oglasne profile."
        },
        {
          "h": "Tko ih još obrađuje",
          "p": "Hosting i sigurnosne kopije: Hetzner, u EU. Plaćanja: Stripe, koji obrađuje podatke o kartici; mi čuvamo samo vaš Stripe ID kupca, plan i status plaćanja. Slanje emailova: naš pružatelj emaila, za potvrde i resetiranje lozinke. Prijava putem Googlea: Google, samo ako to odaberete. Tečajevi dolaze iz javnih podataka ECB-a i ne sadrže vaše podatke."
        },
        {
          "h": "Kolačići i pohrana",
          "p": "Ne koristimo oglasne ni kolačiće za praćenje. Vaš preglednik pohranjuje sesiju prijave, jezik, temu i lokalnu kopiju podataka kako bi aplikacija radila bez mreže."
        },
        {
          "h": "Koliko ih čuvamo",
          "p": "Dok postoji vaš račun. Kad ga obrišete, podaci se odmah brišu iz žive baze. Sigurnosne kopije nestaju unutar 30 dana. Zapise o plaćanju možemo čuvati koliko traži porezni zakon."
        },
        {
          "h": "Vaša prava",
          "p": "Možete pregledati, ispraviti, izvesti i obrisati svoje podatke. Izvoz i brisanje su u izborniku Više, pod Vaši podaci. Možete nas i kontaktirati emailom, prigovoriti obradi ili podnijeti pritužbu Agenciji za zaštitu osobnih podataka (AZOP)."
        },
        {
          "h": "Izmjene",
          "p": "Ako se politika bitno promijeni, obavijestit ćemo vas u aplikaciji ili emailom prije primjene."
        }
      ]
    },
    "terms": {
      "title": "Uvjeti korištenja",
      "sections": [
        {
          "h": "Usluga",
          "p": "{{name}} vam pomaže pratiti vlastiti novac. To je alat, a ne financijski, porezni ni pravni savjet. Iznosi ovise o onome što unesete i o javnim tečajevima."
        },
        {
          "h": "Vaš račun",
          "p": "Morate imati najmanje 16 godina. Čuvajte lozinku i navedite točne podatke. Odgovorni ste za sve što se događa putem vašeg računa. U radne prostore pozivajte samo osobe kojima vjerujete."
        },
        {
          "h": "Vaši podaci",
          "p": "Vaši podaci ostaju vaši. Dopuštate nam da ih pohranjujemo i obrađujemo samo radi pružanja usluge. Možete ih izvesti i obrisati račun u bilo kojem trenutku."
        },
        {
          "h": "Planovi i plaćanje",
          "p": "Kinta je besplatna i sve njezine mogućnosti rade bez plaćanja. Ako je želite podržati, možete kupiti doživotni plan Podupiratelj za 37 EUR, jednokratno. To je jedna uplata, bez probnog razdoblja i bez pretplate. Cijena uključuje PDV gdje se primjenjuje. Dok ga ne kupite, aplikacija otprilike jednom mjesečno prikazuje podsjetnik koji možete odgoditi. Prema pravu EU-a potrošača imate pravo na odustanak u roku 14 dana od kupnje, osim ako ste pristali da usluga počne odmah; javite nam se i vratit ćemo novac kako zakon traži."
        },
        {
          "h": "Dopuštena uporaba",
          "p": "Ne napadajte, ne preopterećujte i ne rastavljajte uslugu, ne koristite je za kršenje zakona i ne pokušavajte doći do tuđih podataka."
        },
        {
          "h": "Dostupnost i odgovornost",
          "p": "Trudimo se da usluga radi i da su vaši podaci sigurni, ali ne jamčimo da će uvijek biti dostupna ni bez pogrešaka. Ne odgovaramo za neizravnu štetu. Ništa ovdje ne ograničava prava koja imate po zakonu."
        },
        {
          "h": "Prestanak usluge",
          "p": "Možete prestati u bilo kojem trenutku brisanjem računa. Možemo suspendirati račune koji krše ove uvjete. Ako ikad ugasimo uslugu, dat ćemo obavijest i vrijeme za izvoz podataka."
        },
        {
          "h": "Pravo",
          "p": "Primjenjuje se hrvatsko pravo. Sporove rješavaju sudovi u Hrvatskoj, bez utjecaja na vaša potrošačka prava u vašoj državi."
        }
      ]
    }
  },
  "settings": {
    "title": "Postavke",
    "account": "Račun",
    "language": "Jezik",
    "theme": "Izgled",
    "themeDark": "Tamni",
    "themeLight": "Svijetli",
    "themeSystem": "Sustav",
    "workspace": "Radni prostor",
    "currency": "Valuta",
    "version": "Verzija {{version}}"
  },
  "home": { "greeting": "Bok{{name}}" },
  "accounts": {
    "title": "Računi",
    "add": "Dodaj račun",
    "edit": "Uredi račun",
    "type": "Vrsta",
    "openingBalance": "Početno stanje",
    "makeDefault": "Koristi kao zadani račun",
    "default": "Zadani",
    "archived": "Arhiviran",
    "archive": "Arhiviraj",
    "unarchive": "Vrati",
    "empty": "Još nema stavki",
    "emptyHint": "Dodaj račun s kojeg plaćaš, npr. karticu ili gotovinu.",
    "deleteTitle": "Obrisati {{name}}?",
    "deleteBody": "Račun nestaje s popisa. Arhiviranje čuva povijest i obično je bolji izbor.",
    "types": { "checking": "Tekući", "cash": "Gotovina", "savings": "Štednja", "credit_card": "Kreditna kartica", "loan": "Kredit", "investment": "Ulaganja", "ewallet": "E-novčanik", "other": "Ostalo" }
  },
  "categories": {
    "title": "Kategorije",
    "add": "Dodaj kategoriju",
    "edit": "Uredi kategoriju",
    "expense": "Troškovi",
    "income": "Prihodi",
    "deleteTitle": "Obrisati {{name}}?",
    "deleteBody": "Prošle transakcije zadržavaju iznose, ali gube ovu kategoriju."
  },
  "rules": {
    "title": "Automatska kategorija",
    "hint": "Kad novi trošak nema kategoriju, a trgovac sadrži tekst, dobiva tu kategoriju.",
    "row": "„{{pattern}}” → {{category}}",
    "pattern": "Trgovac sadrži",
    "category": "Kategorija",
    "add": "Dodaj pravilo",
    "delete": "Obriši pravilo {{pattern}}"
  },
  "import": {
    "title": "Uvoz CSV-a",
    "account": "Uvezi na račun",
    "file": "Izvod banke (CSV)",
    "fileHint": "Do {{max}} redaka. Datoteka se čita na ovom uređaju, a šalju se samo mapirani stupci.",
    "errors": { "empty": "Datoteka nema redaka s podacima.", "tooMany": "Datoteka ima više od {{max}} redaka. Podijeli je i uvezi u dijelovima." },
    "columns": { "date": "Stupac datuma", "amount": "Stupac iznosa", "merchant": "Stupac trgovca", "note": "Stupac bilješke" },
    "choose": "Odaberi stupac",
    "none": "Nema u datoteci",
    "dateFormat": "Oblik datuma",
    "formats": { "iso": "2026-10-17", "dmy-dot": "17.10.2026", "dmy-slash": "17/10/2026", "mdy-slash": "10/17/2026" },
    "positiveIsExpense": "Pozitivni iznosi su troškovi (izvodi kreditnih kartica)",
    "summary": "Spremno redaka: {{ready}}, preskočeno: {{skipped}} (neispravan datum ili iznos).",
    "preview": "Pregled",
    "start": "Uvezi redaka: {{count}}",
    "progress": "Uvoz… {{done}} od {{total}}",
    "done": "Uvoz je gotov",
    "stopped": "Uvoz je prekinut",
    "result": "Dodano ili prepoznato: {{created}}. Preskočeno: {{failed}}.",
    "safeToRetry": "Problem s vezom ili poslužiteljem. Pokušaj ponovno: već uvezeni redci se ne dupliciraju.",
    "retry": "Pokušaj ponovno",
    "needAccount": "Najprije dodaj račun:"
  },
  "receipt": {
    "has": "Ima račun",
    "add": "Dodaj fotografiju računa",
    "replace": "Promijeni fotografiju",
    "remove": "Ukloni fotografiju",
    "file": "Fotografija računa",
    "list": "Računi",
    "delete": "Obriši račun {{name}}",
    "alt": "Račun",
    "download": "Preuzmi",
    "uploadFailed": "Spremljeno, ali fotografija nije učitana. Pritisni Spremi za novi pokušaj."
  },
  "offline": {
    "section": "Još nije sinkronizirano",
    "badgePending": "Čeka sinkronizaciju",
    "badgeFailed": "Nije sinkronizirano",
    "pendingTitle": "Čeka sinkronizaciju",
    "failedTitle": "Sinkronizacija nije uspjela",
    "kind": {
      "create": "Ova nova transakcija je spremljena na ovom uređaju i šalje se čim budeš online.",
      "update": "Ova promjena je spremljena na ovom uređaju i šalje se čim budeš online.",
      "delete": "Ovo brisanje je spremljeno na ovom uređaju i šalje se čim budeš online."
    },
    "failedHint": "Poslužitelj je nije prihvatio. Pokušaj ponovno ili je odbaci.",
    "retry": "Pokušaj ponovno",
    "discard": "Odbaci",
    "discardTitle": "Odbaciti ovu promjenu?",
    "discardBody": "Još nije poslana. Ako je odbaciš, gubi se.",
    "syncing": "Sinkronizacija promjena: {{count}}",
    "queued": "Spremljeno na ovom uređaju, čeka vezu: {{count}}",
    "failedBar": "Promjene koje se nisu sinkronizirale: {{count}}",
    "review": "Pregledaj",
    "photoNeedsConnection": "Fotografije trebaju vezu."
  },
  "bills": {
    "title": "Krediti i pretplate",
    "add": "Dodaj stavku",
    "edit": "Uredi stavku",
    "amount": "Iznos",
    "nextDue": "Sljedeće dospijeće",
    "repeatEvery": "Ponavljaj svakih",
    "unit": "Jedinica",
    "units": { "month": "mjeseci", "week": "tjedana", "year": "godina", "day": "dana" },
    "every1": { "day": "Dnevno", "week": "Tjedno", "month": "Mjesečno", "year": "Godišnje" },
    "everyN": { "day": "Svakih {{n}} dana", "week": "Svakih {{n}} tjedana", "month": "Svakih {{n}} mjeseci", "year": "Svakih {{n}} godina" },
    "none": "Nema",
    "accountHint": "Potrebno za bilježenje plaćanja kao troška.",
    "remindDays": "Podsjeti me toliko dana prije",
    "markPaid": "Plaćeno",
    "payTitle": "Platiti: {{name}}?",
    "recordOn": "Zabilježi i kao trošak na računu {{account}}",
    "recordNeedsAccount": "Dodaj račun ovoj stavci kako bi se plaćanja bilježila kao trošak.",
    "empty": "Još nema stavki",
    "emptyHint": "Dodaj stanarinu, pretplate ili rate i vidi što dospijeva sljedeće.",
    "deleteTitle": "Obrisati ovu stavku?",
    "deleteBody": "Prošla plaćanja ostaju u tvojim transakcijama.",
    "bulkDeleteTitle": "Obrisati odabrane stavke ({{count}})?",
    "due": { "today": "Dospijeva danas", "tomorrow": "Dospijeva sutra", "yesterday": "Dospjelo jučer", "in": "Dospijeva za {{count}} dana", "ago": "Kasni {{count}} dana" },
    "errors": { "interval": "Unesi broj od 1 do 120.", "reminder": "Unesi broj od 0 do 60.", "stale": "Ova stavka je već plaćena. Popis je osvježen." }
  },
  "onboarding": {
    "progress": "Korak {{n}} od {{total}}",
    "next": "Dalje",
    "skipStep": "Preskoči ovaj korak",
    "welcome": {
      "title": "Dobro došli u Kintu",
      "lead": "Minuta postavljanja, a onda je vaša.",
      "body": "Kinta je besplatna, za sve. Plaćate samo ako želite postati podupiratelj, jednokratno, doživotnim planom. Prvo kratki obilazak svakog dijela, zatim vaš prvi račun i budžet.",
      "cta": "Krenimo",
      "skip": "Preskoči upute"
    },
    "tour": {
      "lead": "Čemu služi ovaj dio.",
      "progress": "Dio {{n}} od {{total}}",
      "skip": "Preskoči obilazak",
      "finish": "Postavi moj račun",
      "transactions": {
        "title": "Transakcije",
        "body": "Ovdje su svi troškovi i prihodi. Dodirnite plus, upišite iznos i odaberite kategoriju. Radi i bez interneta. Možete pretraživati, filtrirati ili označiti više njih i obrisati odjednom."
      },
      "budgets": {
        "title": "Budžeti",
        "body": "Zadajte granicu za kategoriju ili cijeli mjesec. Kinta pokazuje koliko je iskorišteno i koliko je sigurno potrošiti te upozori prije prekoračenja."
      },
      "bills": {
        "title": "Krediti i pretplate",
        "body": "Dodajte stanarinu, kredite, rate i pretplate. Dobit ćete podsjetnik prije roka, a oznaka „plaćeno” sama stvara transakciju."
      },
      "goals": {
        "title": "Ciljevi",
        "body": "Štedite za nešto, putovanje ili rezervu. Zadajte cilj i dodajte novac usput da vidite napredak."
      },
      "reports": {
        "title": "Izvještaji",
        "body": "Vidite kamo ide novac: potrošnja po kategorijama, najčešći trgovci te prihodi naspram potrošnje kroz vrijeme."
      },
      "accounts": {
        "title": "Računi i kategorije",
        "body": "Računi su mjesta gdje je vaš novac: banka, kartica ili gotovina. Kategorije razvrstavaju potrošnju. Oboje je pod Više i možete dodati svoje."
      },
      "more": {
        "title": "Više",
        "body": "Postavke, jezik, valuta, dijeljenje radnog prostora s kućanstvom, uvoz iz datoteke te preuzimanje ili brisanje vaših podataka."
      }
    },
    "account": {
      "title": "Vaš prvi račun",
      "lead": "Gdje je vaš novac: bankovni račun, kartica ili gotovina. Kasnije možete dodati još."
    },
    "budget": {
      "title": "Mjesečni budžet",
      "lead": "Neobavezno, a lako se kasnije mijenja.",
      "body": "Koliko želite potrošiti u mjesecu, sve zajedno?",
      "label": "Mjesečna granica ({{currency}})"
    },
    "done": {
      "title": "Sve je spremno",
      "lead": "Dodajte prvu transakciju plus gumbom.",
      "cta": "Otvori Kintu"
    }
  },
  "billing": {
    "badge": "Podupiratelj",
    "thanksSupporter": "Hvala što podupirete Kintu.",
    "since": "Od {{date}}.",
    "inviteTitle": "Kinta je besplatna",
    "inviteBody": "Sve u Kinti je besplatno, za sve. Ako vam koristi, možete postati podupiratelj jednom malom uplatom. Dobivate značku i više nećete vidjeti podsjetnik.",
    "support": "Postani podupiratelj · {{price}}",
    "supporterPlan": "Podupiratelj",
    "reminderTitle": "Sviđa vam se Kinta?",
    "reminderBody": "Kinta je besplatna. Ako vam koristi, autora možete jednokratno podržati doživotnim planom Podupiratelj. Podsjetit ćemo vas ponovno za mjesec dana.",
    "remindLater": "Podsjeti me za 30 dana",
    "thanks": "Hvala! Vaša značka podupiratelja pojavit će se za trenutak.",
    "canceled": "Plaćanje je otkazano. Ništa nije naplaćeno.",
    "mock": {
      "banner": "Probni način: ova stranica zamjenjuje pružatelja plaćanja. Ništa se ne naplaćuje.",
      "title": "Probno plaćanje",
      "invalid": "Ova poveznica za probno plaćanje nije valjana ili je istekla. Krenite ponovno iz Postavki.",
      "pay": "Plati (probno)"
    }
  },
  "reports": {
    "title": "Izvještaji",
    "period": "Razdoblje",
    "presets": { "thisMonth": "Ovaj mjesec", "lastMonth": "Prošli mjesec", "last3": "Zadnja 3 mjeseca", "thisYear": "Ova godina", "custom": "Prilagođeno" },
    "badRange": "Odaberi početni i završni dan, tim redoslijedom, unutar pet godina.",
    "topMerchants": "Najveći trgovci",
    "times": "{{n}}×",
    "export": "Izvoz",
    "exportHint": "Sve transakcije od {{from}} do {{to}} kao datoteka za proračunske tablice (CSV). Istu datoteku možeš ponovno uvesti.",
    "downloadCsv": "Preuzmi CSV"
  },
  "goals": {
    "title": "Ciljevi",
    "new": "Novi cilj",
    "edit": "Uredi cilj",
    "target": "Ciljani iznos",
    "savedSoFar": "Dosad uštedjeno",
    "targetDate": "Postići do",
    "account": "Štedi na računu",
    "statusLabel": "Status",
    "status": { "active": "Aktivan", "paused": "Pauziran", "achieved": "Ostvaren", "archived": "Arhiviran" },
    "by": "Do {{date}}",
    "perMonth": "{{amount}} mjesečno do cilja",
    "addMoney": "Dodaj novac",
    "contributeTitle": "{{name}}",
    "direction": "Dodaj ili podigni",
    "add": "Dodaj",
    "withdraw": "Podigni",
    "empty": "Još nema ciljeva",
    "emptyHint": "Štedi za odmor, fond za nepredviđeno ili novi laptop i prati kako raste.",
    "deleteTitle": "Obrisati ovaj cilj?",
    "deleteBody": "Ovo se ne može poništiti. Tvoje transakcije ostaju netaknute.",
    "bulkDeleteTitle": "Obrisati odabrane ciljeve ({{count}})?",
    "errors": { "saved": "Unesi iznos ili ostavi prazno." }
  },
  "budgets": {
    "add": "Dodaj proračun",
    "edit": "Uredi proračun",
    "for": "Proračun za",
    "targets": { "category": "Kategorija", "group": "Grupa", "all": "Sva potrošnja" },
    "choose": "Odaberi…",
    "overall": "Sva potrošnja",
    "amount": "Limit",
    "period": "Razdoblje",
    "periods": { "weekly": "Tjedno", "monthly": "Mjesečno", "quarterly": "Tromjesečno", "yearly": "Godišnje" },
    "threshold": "Upozori me na (%)",
    "thresholdHint": "Traka postaje žuta kad se potroši ovaj dio limita.",
    "of": "od",
    "left": "Preostalo: {{amount}}",
    "over": "Iznad za {{amount}}",
    "empty": "Još nema proračuna",
    "emptyHint": "Postavi limit za kategoriju, npr. namirnice, i prati kako se puni.",
    "deleteTitle": "Obrisati ovaj proračun?",
    "deleteBody": "Tvoje transakcije ostaju netaknute.",
    "bulkDeleteTitle": "Obrisati odabrane proračune ({{count}})?",
    "errors": { "amount": "Unesi iznos veći od nule.", "threshold": "Unesi broj od 1 do 100.", "exists": "Za ovo i razdoblje već postoji proračun." }
  },
  "dashboard": {
    "safeToSpend": "Sigurno za potrošiti",
    "income": "Prihod",
    "spent": "Potrošeno",
    "net": "Neto",
    "vsLastMonth": "{{change}} potrošnje u odnosu na prošli mjesec",
    "byCategory": "Kamo je otišlo",
    "noSpending": "Ovaj mjesec još nema troškova.",
    "pace": {
      "title": "Tempo potrošnje",
      "thisMonth": "Ovaj mjesec",
      "lastMonth": "Prošli mjesec",
      "perDay": "Po danu",
      "projected": "Procjena",
      "lastByNow": "Prošli mjesec",
      "summary": "Potrošeno {{spent}} ovaj mjesec; prošli mjesec do ovog dana: {{last}}."
    },
    "trend":"Zadnjih 6 mjeseci",
    "savingsRate": "Ovaj mjesec zadržavaš {{rate}} % prihoda.",
    "total": "Ukupno",
    "upcomingBills": "Nadolazeća plaćanja",
    "recent": "Nedavno",
    "seeAll": "Prikaži sve",
    "loadFailed": "Pregled se nije učitao."
  },
  "pages": {
    "transactions": "Transakcije",
    "budgets": "Proračuni",
    "notFound": "Nismo pronašli tu stranicu."
  },
  "quickAdd": { "title": "Dodaj transakciju", "backspace": "Obriši zadnju znamenku", "category": "Kategorija", "more": "Još ({{count}})", "less": "Manje", "failed": "Spremanje nije uspjelo. Pokušaj ponovno." },
  "tx": {
    "noAccount": "Najprije dodaj račun, npr. karticu ili gotovinu. Zatim troškove unosiš u dva dodira.",
    "bulk": {
      "select": "Odaberi",
      "cancel": "Odustani",
      "selectAll": "Odaberi sve",
      "selected": "Odabrano: {{count}}",
      "limit": "ograničenje {{max}}",
      "setCategory": "Postavi kategoriju",
      "chooseCategory": "Odaberi kategoriju",
      "apply": "Primijeni",
      "deleteTitle": "Obrisati odabrane transakcije ({{count}})?"
    },
    "search": "Traži trgovca ili bilješku",
    "filters": {
      "title": "Filteri",
      "withCount": "Filteri, aktivnih: {{count}}",
      "any": "Bilo koji",
      "uncategorized": "Bez kategorije",
      "from": "Od",
      "to": "Do",
      "clear": "Očisti sve",
      "done": "Gotovo",
      "noMatch": "Ništa ne odgovara ovim filterima"
    },
    "edit": "Uredi transakciju",
    "kind": "Vrsta",
    "moreDetails": "Više detalja",
    "merchant": "Trgovac",
    "account": "Račun",
    "fromAccount": "S računa",
    "toAccount": "Na račun",
    "chooseAccount": "Odaberi račun",
    "date": "Datum",
    "note": "Bilješka",
    "deleteTitle": "Obrisati ovu transakciju?",
    "deleteBody": "Nestaje s popisa, stanja i zbrojeva.",
    "today": "Danas",
    "yesterday": "Jučer",
    "loadMore": "Učitaj više",
    "loadFailed": "Transakcije se nisu učitale.",
    "empty": "Još nema transakcija",
    "emptyHint": "Dodirni + za prvi trošak.",
    "type": { "expense": "Trošak", "income": "Prihod", "transfer": "Prijenos" }
  }
}
